export default __webpack_public_path__ + "static/media/metamask.dabbc866.png";